import "bootstrap/dist/css/bootstrap.min.css";
import "../../dist/custom.scss";
import leuwint from "../../images/leuwint.jpeg";
import "./Signup.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { signUp } from "../../../utilities/apis";
import { uploadResume } from "../../../utilities/apis";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../Loader";
import { setUserRole } from "../../../app/state/userSlice";

function Signup() {
  const initialState = {
    emailId: "",
    name: "",
    mobNo: "",
    companyName: "",
    skills: "",
    preferredLocation: [],
    userType: "",
  };
  const [file, setFile] = useState(null);
  const [userState, setUserState] = useState(initialState);
  const [emailError, setEmailError] = useState("");
  const [showEmployeeField, setShowEmployeeField] = useState(false);
  const [hideFields, setHideFields] = useState(true);
  const [isUploading, setIsUploading] = useState(false);
  const selectUserEmail = useSelector((state) => state.user.userID);
  const [errors, setErrors] = useState({});


  const validateFields = () => {
    const newErrors = {};

    if (!userState.emailId) {
      newErrors.emailId = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(userState.emailId)) {
      newErrors.emailId = "Email is invalid";
    }

    if (!userState.name) {
      newErrors.name = "Name is required";
    }

    if (!userState.mobNo) {
      newErrors.mobNo = "Contact number is required";
    }

    if (userState.userType === "employee" && !userState.skills) {
      newErrors.skills = "Skills are required";
    }

    if (userState.userType === "employer" && !userState.companyName) {
      newErrors.companyName = "Company name is required";
    }

    if (!userState.preferredLocation) {
      newErrors.preferredLocation = "Preferred location is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    var defaultRadioButton = document.getElementById("flexRadioDefault2");
    defaultRadioButton.checked = true;
    setUserState((prevState) => ({
      ...prevState,
      userType: defaultRadioButton.value,
    }));
  }, []);

  useEffect(() => {
    setShowEmployeeField(userState.userType === "employee");
    setHideFields(userState.userType === "employee");
    setUserState((prev) => ({
      ...prev,
      name: "",
      mobNo: "",
      companyName: "",
      skills: "",
      preferredLocation: [],
    }));
  }, [userState.userType]);

  useEffect(() => {
    setUserState((prev) => ({
      ...prev,
      emailId: selectUserEmail,
    }));
  }, [selectUserEmail]);

  const handleFile = async (e) => {
    try {
      if (e) {
        const selectedFile = e.target.files[0];
        await setFile(selectedFile);
        if (!selectedFile) {
          console.log("No file selected.");
          return;
        }
      }
      const formData = new FormData();
      return formData;
    } catch (error) {
      alert(error);
    }
  };

  const handleFileUpload = async (e) => {
    e.preventDefault();
    if (!file) {
      alert("No file Selected");
      return;
    }
    setIsUploading(true);
    const fD = await handleFile();
    fD.append("resume", file, "Resume_Sample.pdf");
    fD.append("user_id", selectUserEmail);

    try {
      const resumeResponse = await uploadResume(fD);
      if (resumeResponse) {
        setIsUploading(false);
        setHideFields(false);
        const { person_name, contact_number, locations, skills } = resumeResponse[0];
        const preferredLocationn = locations.length === 0 ? "India" : locations;
        setUserState((prevState) => ({
          ...prevState,
          emailId: selectUserEmail,
          name: person_name,
          mobNo: contact_number,
          preferredLocation: preferredLocationn,
          skills: skills,
        }));
      }
      console.log("Resume uploaded successfully");
    } catch (error) {
      console.error("Error uploading resume:", error);
    }
  };

  const signUpApi = async () => {
    const signupRes = await signUp(userState);
    if (signupRes.success === true) {
      navigate("/home");
    } else {
      alert(signupRes.message);
    }
  };

  useEffect(() => {
    console.log(userState);
  }, [userState]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateFields()) {
      return;
    }

    if (userState.userType === "employee") {
      setUserState((prevState) => ({
        ...prevState,
        companyName: "NA",
      }));
    } else if (userState.userType === "employer") {
      setUserState((prevState) => ({
        ...prevState,
        skills: "NA",
      }));
    }

    try {
      await signUpApi(userState);
      console.log("Form submitted!");
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Error submitting form. Please try again later.");
    }
    dispatch(setUserRole(userState.userType));
    console.log("Form Submitted.");
  };


  const resumeField = (
    <>
      <small id='emailHelp' class='form-text text-muted mb-3'>
        Upload your CV here!
      </small>
      <div class='input-group'>
        <input type='file' name='resume' class='form-control form-inp mb-3' id='inputGroupFile02' onChange={handleFile} />

        <button class='input-group-text mb-3' for='inputGroupFile02' id='fileInput' onClick={handleFileUpload}>
          Upload
          {isUploading && <Loader></Loader>}
        </button>
      </div>
    </>
  );

  const skillsField = (
    <div>
      <input
        onChange={handleChange}
        type='text'
        name='skills'
        id='form3Example3'
        value={userState.skills}
        className={`form-control form-inp mb-3 ${errors.skills ? "is-invalid" : ""}`}
        disabled={hideFields}
        style={{
          borderRadius: "18px",
          textAlign: "center",
        }}
        required
      />
      {errors.emailId && <span className="text-danger">{errors.emailId}</span>}
    </div>
  );

  const companyField = (
    <div>
      <input
        onChange={handleChange}
        type='text'
        id='form3Example3'
        name='companyName'
        className={`form-control form-inp mb-3 ${errors.companyName ? "is-invalid" : ""}`}
        disabled={hideFields}
        style={{
          borderRadius: "18px",
          textAlign: "center",
        }}
        required
      />
    </div>
  );

  return (
    <>
      <section class='vh-100'>
        <div class='container-fluid h-custom'>
          <div class='row d-flex justify-content-center align-items-center vh-100' id='login'>
            <div class='col-md-9 col-lg-6 col-xl-5'>
              <img src={leuwint} className='img-fluid align-self-start' alt='logo' />
            </div>
            <div class='col-md-8 col-lg-6 col-xl-4 mt-5'>
              <div className='card shadow round' style={{ height: 700 }}>
                <div className='card-body py-4 px-md-4' id='signincrd'>
                  <h3 className='fw-bold ls-tight text-primary text-center'>Sign up</h3>

                  <div className='container'>
                    <div className='row'>
                      <div className='col-sm-12 d-flex justify-content-center radioButtons px-0'>
                        <div className='form-check-inline'>
                          <button className='btn radioButton'>
                            <input className='form-check-input' type='radio' name='userType' value='employer' onChange={handleChange} id='flexRadioDefault1' />
                            <label className='form-check-label' htmlFor='flexRadioDefault1' style={{ fontSize: "small" }}>
                              Employer
                            </label>
                          </button>
                        </div>
                        <div className='form-check-inline'>
                          <button className='btn radioButton'>
                            <input className='form-check-input' type='radio' name='userType' value='employee' onChange={handleChange} id='flexRadioDefault2' />
                            <label className='form-check-label' htmlFor='flexRadioDefault2' style={{ fontSize: "small" }}>
                              Employee
                            </label>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <form className='mt-4'>
                    <div className='row fromRow'>
                      <div className='form-outline  frmsn mb-3'>
                        {showEmployeeField && resumeField}
                        <small class='form-text text-muted'>Email*</small>
                        <input
                          onChange={handleChange}
                          name='emailId'
                          type='email'
                          value={selectUserEmail}
                          className='form-control form-inp mb-3'
                          placeholder=''
                          style={{
                            borderRadius: "18px",
                            textAlign: "center",
                          }}
                          disabled={true}
                          required
                        />
                        <small class='form-text form-text-danger text-muted mb-3'>{emailError}</small>
                        {/* <br></br> */}
                        <small class='form-text text-muted mt-5'>Name*</small>
                        <input
                          onChange={handleChange}
                          name='name'
                          type='text'
                          value={userState.name}
                          className={`form-control form-inp mb-3 ${errors.name ? "is-invalid" : ""}`}
                          aria-describedby='passwordHelpBlock'
                          disabled={hideFields}
                          style={{
                            borderRadius: "20px",
                            textAlign: "center",
                          }}
                          required
                        />
                        {/* {errors.name && <span className="text-danger">{errors.name}</span>} */}

                        {/* <br></br> */}
                        <small class='form-text text-muted mt-5'>Contact Number*</small>
                        <input
                          onChange={handleChange}
                          name='mobNo'
                          type='tel'
                          value={userState.mobNo}
                          className={`form-control form-inp mb-3 ${errors.mobNo ? "is-invalid" : ""}`}
                          aria-describedby='passwordHelpBlock'
                          disabled={hideFields}
                          style={{
                            borderRadius: "20px",
                            textAlign: "center",
                          }}
                          required
                        />
                        <small id='emailHelp' class='form-text text-muted mb-3'>
                          {userState.userType === "employee" ? "Skills" : "Company Name*"}
                        </small>
                        <div>{showEmployeeField && skillsField}</div>
                        <div>{!showEmployeeField && companyField}</div>
                        <small class='form-text text-muted'>Prefered Location</small>
                        <input
                          onChange={handleChange}
                          type='text'
                          name='preferredLocation'
                          value={userState.preferredLocation}
                          id='form3Example3'
                          className={`form-control form-inp mb-3 ${errors.preferredLocation ? "is-invalid" : ""}`}
                          disabled={hideFields}
                          style={{
                            borderRadius: "18px",
                            textAlign: "center",
                          }}
                          required
                        />
                        {/* {errors.preferredLocation && <span className="text-danger">{errors.preferredLocation}</span>} */}

                      </div>

                      <div className='d-flex justify-content-center'>
                        <button type='submit' className='btn btn-primary btn-sm mb-3 p-2 mt-4 register rounded-pill' style={{ width: "150px" }} onClick={handleSubmit}>
                          Register
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Signup;
